import React from 'react';
import { Badge } from '../ui-kit';

const BetaIndicator = () => <Badge variant="primary">{I18n.t('beta')} </Badge>;

export default BetaIndicator;
